var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcJewerly = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m4.219 3.04-2.844 5.2c-.463.76-.49.943-.12 1.395L11.412 22a1.414 1.414 0 0 0 2 0l9.73-12.382c.32-.409.27-.618-.032-1.275l-2.526-5.215A2 2 0 0 0 18.784 2H5.974a2 2 0 0 0-1.755 1.04M9.677 8l.5-4h4.469l.5 4zM8.147 4l-.5 4H3.786l2.187-4zm9.123 6-2.097 6.522L20.297 10zm-.092-2-.5-4h2.106l1.937 4zm-7.43 8.823L4.144 10h3.411zM14.841 10l-2.429 8.5L9.984 10z",
  clipRule: "evenodd"
})));
export default SvgIcJewerly;